module.exports = "https://cdn2-fs.clearscore.com/flux/images/d912b7f39b3bb2622ccb3dfe3ae08bb1.jpg";